import { homeSecurityPortalApi } from 'data/axios';
import { TBabyPlanList, TSkipList, TSkipReason } from 'typings';
import { ApiResponse } from './HttpRequest';
import { PIGGYBANK_ENDPOINTS } from './endpoints';

// Save the user's reason for skipping the Baby free trial.
export async function babySkipFreeTrialReason(payload: TSkipReason) {
  const response = await homeSecurityPortalApi.post(
    PIGGYBANK_ENDPOINTS.BABY_USER_SKIP_REASON,
    payload
  );
  return response;
}

// Fetch the list of skip-trial reasons for the Baby product.
export async function babySkipFreeTrialList(): Promise<
  ApiResponse<TSkipList[]>
> {
  const response = await homeSecurityPortalApi.get(
    PIGGYBANK_ENDPOINTS.BABY_TRIAL_SKIP_REASON
  );
  return response;
}

// Fetch active Baby SKUs available in the given country.
export async function getBabyPlans(
  country: string
): Promise<ApiResponse<TBabyPlanList[]>> {
  const response = await homeSecurityPortalApi.get(
    PIGGYBANK_ENDPOINTS.BABY_PLAN_LIST(country)
  );
  return response;
}
